<template>
    <div id="reportProblem">
        <div class="reportProblem-link-container">
            <button type="button" class="btn btn-link" v-b-modal.report-modal v-on:click="initName()">Report a Problem/Change</button>
        </div>
        <b-modal id="report-modal" size="lg" static title="Report a Problem/Change" role="dialog" aria-hidden="true">
            <template v-slot:default="{ hide}">
                <div>
                    <form novalidate>
                        <div class="form-group">
                            <label for="resourceName">Subject/Resource Name<span class="required-input">*</span></label>
                            <input type="text" class="form-control" id="resourceName" name="resourceName" v-model="resourcename">
                        </div>
                        <div class="form-group">
                            <label for="fromName">Your Name<span class="required-input">*</span></label>
                            <input type="email" class="form-control" id="fromName" name="fromName" v-model="fromName">
                        </div>
                        <div class="form-group">
                            <label for="fromEmail">Your Email Address<span class="required-input">*</span></label>
                            <input type="email" class="form-control" id="fromEmail" name="fromEmail" v-model="fromEmail">
                        </div>
                        <div class="form-group">
                            <label for="emailBody">Describe the problem/update<span class="required-input">*</span></label>
                            <textarea class="form-control" id="emailBody" name="emailBody" v-model="emailBody"
                                      rows="5"/>
                        </div>
                    </form>
                    <div id="recaptcha" class="g-recaptcha"></div>
                    <div class="form-errors" v-if="errors.length">
                        <b>Please correct the following error(s)</b>
                        <p class="error" v-for="err in errors" :key="err">{{err}}</p>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer="{}">
                <div>
                    <button type="button" class="btn btn-primary" :disabled="!response" @click="submit()">Submit</button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "ReportProblem",
        props: ['resource'],
        data (){
            return {
                errors: [],
                response: null,
                fromName: null,
                fromEmail: null,
                emailBody: null,
                resourcename: null
            }
        },
        mounted (){
          this.initReCaptcha();
        },
        methods: {
            initReCaptcha: function(){
                var self = this;
                setTimeout(function(){
                    if(typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.render === 'undefined'){
                        self.initReCaptcha();
                    } else {
                        window.grecaptcha.render('recaptcha', {
                            sitekey: '6LfO5swUAAAAANmKoxCMCPMLxsoWfP4zGmJRwawE',
                            size: 'checkbox',
                            callback: self.getResponse
                        })
                    }
                }, 100)
            },
            initName: function(){
                this.resourcename = this.resource.name
            },
            submit (){
                this.errors = [];

                if(!this.resourcename){
                    this.errors.push("Please enter a subject or resource name.")
                }
                if(!this.fromName){
                    this.errors.push("Please enter your name.");

                }

                if(!this.fromEmail){
                    this.errors.push("Please enter your email address.");
                } else if(!this.validateEmail(this.fromEmail)){
                    this.errors.push("Please enter a valid email address.");
                }

                if(!this.emailBody){
                    this.errors.push("Please enter details about the problem/update");
                }

                if(!this.response){
                    this.errors.push("Please complete the ReCaptcha");
                }

                if(this.errors.length === 0){
                    let data = {
                        resource: this.resourcename,
                        fromName: this.fromName,
                        fromEmail: this.fromEmail,
                        emailBody: this.emailBody,
                        response: this.response
                    };

                    axios.post("/api/report.php", data).then(response => {
                        this.$bvModal.hide("report-modal");
                        window.grecaptcha.reset();
                        this.fromName = null;
                        this.fromEmail = null;
                        this.emailBody = null;
                        this.response = null;

                        if(response.data){
                            if(!response.data.success){
                                alert(response.data.message);
                            }
                        }
                    });
                }
            },
            getResponse (token){
                this.response = token;
            },
            validateEmail(email) {
                // eslint-disable-next-line no-useless-escape
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        }
    }
</script>

<style scoped>
    .reportProblem-link-container {
        text-align: center;
    }

    .reportProblem-link-container > button {
        padding: 0;
    }
    .required-input {
        color: red;
    }
    .form-errors {
        color: red;
    }

    #reportProblem {
        text-align: left;
    }
</style>